import React from "react";
import { useTranslation } from "react-i18next";
import { WeeklyCalendar } from "@planzone/dto";
import { useEditResourceWeeklyCalendar } from "@planzone/view-models";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import styles from "./styles.scss";

function Calendar({ resource, calendar }: Props) {
  const { t } = useTranslation();
  const [form, setForm] = React.useState(calendar);
  const { isRequestPending: isEditRequestPending, editResourceWeeklyCalendar } =
    useEditResourceWeeklyCalendar(resource);
  const dayStatus: { id: number; day: string; capacity: number }[] = [
    { id: 1, day: "planning.monday", capacity: form.monday.capacity },
    { id: 2, day: "planning.tuesday", capacity: form.tuesday.capacity },
    { id: 3, day: "planning.wednesday", capacity: form.wednesday.capacity },
    { id: 4, day: "planning.thursday", capacity: form.thursday.capacity },
    { id: 5, day: "planning.friday", capacity: form.friday.capacity },
    { id: 6, day: "planning.saturday", capacity: form.saturday.capacity },
    { id: 7, day: "planning.sunday", capacity: form.sunday.capacity },
  ];

  const handleChange = (nextForm: Partial<WeeklyCalendar>) => {
    setForm({ ...form, ...nextForm });
  };

  const sendData = () => {
    editResourceWeeklyCalendar({ resource, calendar, nextCalendar: form });
  };

  React.useEffect(() => {
    setForm(calendar);
  }, [calendar]);

  function updateCalendar(day: number, target: any): void {
    if (day === 1) {
      handleChange({ monday: { capacity: +target.value } });
    } else if (day === 2) {
      handleChange({ tuesday: { capacity: +target.value } });
    } else if (day === 3) {
      handleChange({ wednesday: { capacity: +target.value } });
    } else if (day === 4) {
      handleChange({ thursday: { capacity: +target.value } });
    } else if (day === 5) {
      handleChange({ friday: { capacity: +target.value } });
    } else if (day === 6) {
      handleChange({ saturday: { capacity: +target.value } });
    } else {
      handleChange({ sunday: { capacity: +target.value } });
    }
  }

  return (
    <div>
      <h2 className={styles.title}>{t("editResource.capacity")} :</h2>
      <div className={styles.calendar}>
        <div className={styles.column}>
          <div className={styles.case} />
          <p className={styles.case}>
            <AllocationUnit format="text" amount={24} />
          </p>
        </div>
        {dayStatus.map((day) => (
          <div key={day.id} className={styles.column}>
            <p className={styles.case}>{t(day.day)}</p>
            <form
              className={styles.formData}
              onSubmit={(e) => {
                e.preventDefault();
                !isEditRequestPending && sendData();
              }}
            >
              <input
                type="number"
                className={styles.input}
                min="0"
                max="24"
                value={day.capacity}
                onChange={({ target }) => updateCalendar(day.id, target)}
                onBlur={() => !isEditRequestPending && sendData()}
              />
            </form>
          </div>
        ))}
      </div>
    </div>
  );
}

export { Calendar };
